import NavBar from '@/components/Nav.vue';
import functions from '@/functions.js';

export default {
    name: 'CalendarPage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            data: {}
        }
    },
    created() {
        this.getProductList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getProductList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('product', {params: {calendar: true, page: this.page}}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    result.data.products.forEach(product => {
                        if (typeof this.data[product.release_time] == 'undefined') {
                            this.data[product.release_time] = {
                                release_day: functions.dateFormat('mm月dd日', product.release_time),
                                release_time: functions.dateFormat('HH:ii', product.release_time),
                                products: []
                            };
                        }
                        this.data[product.release_time].products.push(product);
                    })
                })
            }
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getProductList();
            }
        }
    }
}